<template>
  <div class="home">
    <div class="register-success">
      <p class="success">恭喜您已注册成功！ </p>
      <a class="download" href="http://t.cn/Aijv8II4">去下载</a> 
   </div>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'Home',
  data(){
    return{
      tiem: '',
    }
  },
  created(){
  },
  methods: {
  }
}
</script>

<style lang="scss">
.home {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background: url("../../assets/shareregimg/img1.jpg");
  background-size:100% 100%;
}
.register-success{
  position: absolute;
  width: 200px;
  height: 120px;
  top: 65%;
  left: 50%;
  margin-left: -100px;
  margin-top: -60px;
  text-align: center;
  .success{
    text-align: center;
    font-size: 20px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(255,165,0,1);
  }
  .download{
    display:block;
    text-align: center;
    width: 90%;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    font-size: 16px;
    font-family:PingFangSC-Semibold;
    font-weight:500;
    color:rgba(255,255,255,1);
    margin: 40px auto 0;
    background:linear-gradient(180deg,rgba(254,183,50,1) 0%,rgba(243,152,0,1) 100%);
  }
}
</style>
